import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import image from '@/assets/img/intro-webinesh.jpeg';
import FalconCloseButton from '@/components/common/FalconCloseButton';

const SeoExtension = () => {
  const [show, setShow] = useState(true);
  return (
    show && (
      <div className="settings my-3">
        <Card className="p-0 rounded-2 position-relative">
          <div
            className="position-absolute"
            style={{ right: '6px', top: '3px' }}
          >
            <FalconCloseButton
              size="sm"
              className="fs--2"
              noOutline
              onClick={() => setShow(false)}
            />
          </div>
          <Card.Body className="text-center">
            <img src={image} alt="" width={120} />
            <p className="fs--1 mt-2">
              وِبینش، مثل گوگل آنالیتیکس
              <br />
              ولی با امکانات بیشتر
            </p>
            <div className="d-grid gap-2">
              <Button
                variant="falcon-primary"
                as="a"
                href="https://panel.webinesh.ir/?utm_source=mizfa.tools&utm_medium=referral&utm_campaign=intro-webinesh&utm_content=banner-under-menu-in-panel"
                target="_blank"
                size="sm"
              >
                عضویت + نصب
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    )
  );
};

export default SeoExtension;
